<template>
  <label
    class="checkbox"
    :class="[{ ['-disabled']: disabled, indeterminate, 'indeterminate-fix': indeterminateTransitionFix }, radio ? '-radio' : '-checkbox']"
  >
    <span
      v-if="!!$slots.before"
      class="label -before"
      :class="{ faint: disabled }"
    >
      <slot name="before" />
    </span>
    <input
      type="checkbox"
      class="visible-for-screenreader-only"
      :disabled="disabled"
      :checked="modelValue"
      :indeterminate="indeterminate"
      @change="$emit('update:modelValue', $event.target.checked)"
    >
    <i
      class="input checkbox-indicator"
      :aria-hidden="true"
      :class="[{ disabled }, radio ? '-radio' : '-checkbox']"
      @transitionend.capture="onTransitionEnd"
    />
    <span
      v-if="!!$slots.default"
      class="label -after"
      :class="{ faint: disabled }"
    >
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  props: ['radio', 'modelValue', 'indeterminate', 'disabled'],
  emits: ['update:modelValue'],
  data: (vm) => ({
    indeterminateTransitionFix: vm.indeterminate,
  }),
  watch: {
    indeterminate(e) {
      if (e) {
        this.indeterminateTransitionFix = true
      }
    },
  },
  methods: {
    onTransitionEnd() {
      if (!this.indeterminate) {
        this.indeterminateTransitionFix = false
      }
    },
  },
}
</script>

<style lang="scss">
@use "../../mixins";

.checkbox {
  position: relative;
  display: inline-flex;
  min-height: 1.2em;
  align-items: baseline;
  gap: 0 0.5em;

  /* settings rows set their own column gap through the subgrid */
  .setting-item & {
    gap: inherit;
  }

  &-indicator,
  & .label {
    align-self: center;
  }

  & > &-indicator {
    /* Reset .input stuff */
    padding: 0;
    margin: 0;
    position: relative;
    line-height: inherit;
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    box-shadow: none;

    --_shadow: var(--shadow);
  }

  /* the box, centred like the mark over it */
  &-indicator::before {
    position: absolute;
    inset: 0;
    margin: auto;
    display: block;
    content: "";
    width: 1.1em;
    height: 1.1em;
    border-radius: var(--roundness);
    box-shadow: var(--_shadow);
    background-color: var(--background);
    vertical-align: top;
    text-align: center;
    line-height: 1.1em;
    font-size: 1.1em;
    overflow: hidden;
    box-sizing: border-box;
  }

  /* the mark, over the box drawn by ::before */
  &-indicator::after {
    @include mixins.mark(check);

    color: var(--text);
    opacity: 0;
    transition: opacity 200ms;
  }

  &.-radio {
    .checkbox-indicator {
      &,
      &::before {
        border-radius: var(--r-pill);
      }

      &::after {
        @include mixins.mark(dot);
      }
    }
  }

  .disabled {
    .checkbox-indicator::before {
      background-color: transparent;
    }
  }

  input[type="checkbox"] {
    &:checked + .checkbox-indicator::after {
      opacity: 1;
    }

    &:indeterminate + .checkbox-indicator::after {
      @include mixins.mark(dash);

      opacity: 1;
    }
  }

  &.indeterminate-fix {
    input[type="checkbox"] + .checkbox-indicator::after {
      @include mixins.mark(dash);
    }
  }
}
</style>
